import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SfxBtnIcon from "src/components/button/SfxBtnIcon.vue"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { computed } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxBtnUndo',
  props: {
  modelValue: {
    required: true,
  },

  originalValue: {
    required: true,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const currentModel = computed({
  get() {
    return props.modelValue
  },

  set(value) {
    return emit("update:modelValue", value)
  },
})

//endregion

//region Functions

function resetValue() {
  currentModel.value = props.originalValue
}

//endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SfxBtnIcon, {
    icon: _unref(Icons).UNDO,
    color: "transparent",
    "text-color": "navy-base",
    onClick: resetValue
  }, null, 8, ["icon"]))
}
}

})